import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame } from "lucide-react";
import ShareButtons from "../components/ShareButtons";

export default function DailyVerse() {
  const [today, setToday] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get("/verses/today").then((r) => setToday(r.data)).catch(() => {});
    api.get("/verses").then((r) => setHistory(r.data.items)).catch(() => {});
  }, []);

  return (
    <div data-testid="daily-verse-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="overline">॥ नित्य श्लोक ॥</div>
      <h1 className="font-serif text-5xl lg:text-6xl text-[#4A0E17] mt-2 leading-tight">The Daily Verse</h1>
      <p className="text-[#63534E] mt-5 text-lg max-w-2xl leading-relaxed">
        Every sunrise a verse — chosen to accompany your day's intention. Subscribe to receive it in your inbox at dawn.
      </p>

      {today && (
        <div data-testid="today-verse-card" className="mt-14 bg-[#FFFDF9] sacred-border rounded-3xl p-10 md:p-14 relative overflow-hidden om-watermark">
          <div className="flex items-center gap-2">
            <Flame className="w-4 h-4 text-[#E65100]" />
            <span className="overline">Today · {today.date}</span>
          </div>
          <p className="font-devanagari text-3xl md:text-4xl text-[#4A0E17] leading-loose whitespace-pre-line mt-6">{today.sanskrit}</p>
          {today.transliteration && (<p className="mt-5 italic text-[#63534E] text-lg leading-relaxed">{today.transliteration}</p>)}
          <p className="mt-6 text-[#1F1412] text-lg leading-relaxed">{today.translation}</p>
          {today.reference && (<p className="mt-6 overline text-[#8C6D3B]">— {today.reference}</p>)}
          <div className="mt-8 pt-6 border-t border-[#D4AF37]/30">
            <ShareButtons
              title={`Pancham Dham · Verse of ${today.date}`}
              text={`${today.sanskrit}\n\n${today.translation}\n\n— ${today.reference || "Pancham Dham"}`}
              hashtags={["Shiva", "PanchamDham", "DailyVerse"]}
            />
          </div>
        </div>
      )}

      {history.length > 1 && (
        <div className="mt-20">
          <h2 className="font-serif text-3xl text-[#4A0E17]">Earlier verses</h2>
          <div className="mt-8 space-y-6">
            {history.slice(1).map((v) => (
              <div key={v.id} data-testid={`verse-history-${v.date}`} className="bg-[#FFFDF9] sacred-border rounded-2xl p-6">
                <div className="overline">{v.date}</div>
                <p className="font-devanagari text-xl text-[#4A0E17] mt-3 leading-relaxed">{v.sanskrit}</p>
                <p className="text-[#63534E] mt-3">{v.translation}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
